import React, { useState } from "react";
import "./supportemail.css";
import { useNavigate, useOutletContext } from "react-router-dom";
import Swal from "sweetalert2";
import ProfileHeader from "../../profile/components/ProfileHeader";
import { ArrowLeft } from "lucide-react";

const SupportEmail = () => {
  const { openSidebar } = useOutletContext();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.subject || !form.message) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Please fill subject and description",
      });
      return;
    }

    // 🔥 API / mail service later connect karna
    Swal.fire({
      icon: "success",
      title: "Email Sent",
      text: "Our support team will contact you soon.",
    });

    setForm({ subject: "", message: "" });
  };

  return (
    <div className="rp-support-page">
      <ProfileHeader onMenuClick={openSidebar} val="Email Support" />
      <div className="rp-support-actions">
          <button onClick={()=>navigate('/supports')}  type="button" className="rp-create-leads-save-btn">
             <ArrowLeft size={16}/> Back
          </button>
        </div>
      <div className="rp-support-card">
        {/* Dummy Email */}
        <div className="rp-support-email-box">
          <span>Support Email</span>
          <strong>support@yourcompany.com</strong>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="rp-support-form">
          <div className="rp-support-field">
            <label>Subject</label>
            <input
              type="text"
              name="subject"
              placeholder="Enter subject"
              value={form.subject}
              onChange={handleChange}
            />
          </div>

          <div className="rp-support-field">
            <label>Description</label>
            <textarea
              name="message"
              rows="5"
              placeholder="Describe your issue..."
              value={form.message}
              onChange={handleChange}
            />
          </div>

          <button type="submit" className="rp-support-btn">
            Send Email
          </button>
        </form>
      </div>
    </div>
  );
};

export default SupportEmail;
